import { render, staticRenderFns } from "./ConfirmDialog2.vue?vue&type=template&id=580a3cc5&"
import script from "./ConfirmDialog2.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialog2.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDialog2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports